/* eslint-disable @typescript-eslint/naming-convention */
const JOB_TYPE = {
  '3': '社招',
  '1': '应届',
  '2': '实习',
};

export enum JOB_TYPE_ENUM {
  YINGJIE = '1',
  SHIXI = '2',
  SOCIAL = '3',
}

export enum JOB_SPECIAL_CODE {
  YINGJIE = '1',
  ZHUANZHENGSHIXI = '2',
  BEIDOU = '3',
  QIHANG = '4',
  SOCIAL = '5',
  XIANGMUSHIXI = '6',
  /** 零食杂售管培生 */
  TRAINEE = '7',
  /** LongCat 大模型人才招 */
  LONGCAT = '8',
}

// 职位状态 上线下线
export enum JOB_STATUS {
  ONLINE = '000',
  OFFLINE = '001',
}

export const POSITION_STATE = {
  '1': '应届',
  '2': '实习',
  '3': '社招',
};

export const JOB_SPECIAL_STATE = {
  '1': '校园招聘',
  '2': '转正实习',
  '3': '北斗计划',
  '4': '零售启航计划',
  '5': '社会招聘',
  '6': '日常实习',
  '7': '食杂零售管培生计划',
  '8': 'LongCat大模型人才校招',
};

// 职位来源
export enum JOB_SOURCE {
  SOCIAL = '1',
  CAMPUS = '2',
}

const getJobType = (type) => {
  return JOB_TYPE[type] || '社招';
};

export { JOB_TYPE, getJobType };
